import axios from "axios";

export const AUTH_KEY = "zitec_auth_user";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

// Sessão salva no login: localStorage com "Lembrar de mim", senão sessionStorage (some ao fechar o navegador)
export const readSession = () => {
  for (const store of [localStorage, sessionStorage]) {
    try { const s = JSON.parse(store.getItem(AUTH_KEY)); if (s?.token) return s; } catch { /* sessão inválida */ }
  }
  return null;
};
export const clearSession = () => { localStorage.removeItem(AUTH_KEY); sessionStorage.removeItem(AUTH_KEY); };

// JWT do login em todas as chamadas; o backend identifica o autor das ações pelo token
api.interceptors.request.use((cfg) => {
  const s = readSession();
  if (s) cfg.headers.Authorization = `Bearer ${s.token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Token expirado/inválido fora das telas de login: encerra a sessão e volta para o login
    if (err.response?.status === 401 && !err.config?.url?.startsWith("/auth/") && readSession()) {
      clearSession();
      window.location.assign("/login");
    }
    const d = err.response?.data;
    const status = err.response?.status;
    // 404 sem "detail" chega como ProblemDetails do ASP.NET (title "Not Found"): troca por um texto em português
    const msg = d?.detail || (status === 404 ? "Registro não encontrado." : d?.title)
      || (status ? `Erro ${status}` : `API indisponível em ${BACKEND_URL} — o backend está rodando?`);
    // status junto, para as telas tratarem casos esperados (ex.: chamado excluído) sem mostrar toast de erro
    return Promise.reject(Object.assign(new Error(msg), { status }));
  },
);
